import { SiteJuridiction } from '../site-juridiction';
import { UrgenceRequete } from '../urgence-requete';

export const enum JuridictionCodeEnum {
    TA = 'TA',
    CAA = 'CAA',
    CE = 'CE'
}

export class TypeJuridiction {
    id: number;
    libelle: string;
    code: JuridictionCodeEnum;
    urgencesRequete: Array<UrgenceRequete>;
    siteJuridictions: Array<SiteJuridiction>;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/type-juridiction/type-juridiction.model.ts